import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface BookingDto {
  id: number;
  name: string;
  organizationId: number;
  invoiceId?: number;
  scheduledDateTime: string;
  status?: string;
}

export interface BookingCreateDto {
  name: string;
  organizationId: number;
  invoiceId?: number;
  scheduledDateTime: string;
  status?: string;
}

export interface BookingUpdateDto {
  name: string;
  invoiceId?: number;
  scheduledDateTime: string;
  status?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BookingService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/bookings';

  getAll(): Observable<BookingDto[]> {
    return this.http.get<BookingDto[]>(this.apiUrl);
  }

  getById(id: number): Observable<BookingDto> {
    return this.http.get<BookingDto>(`${this.apiUrl}/${id}`);
  }

  create(data: BookingCreateDto): Observable<BookingDto> {
    return this.http.post<BookingDto>(this.apiUrl, data);
  }

  update(id: number, data: BookingUpdateDto): Observable<BookingDto> {
    return this.http.put<BookingDto>(`${this.apiUrl}/${id}`, data);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
